export const main_links = [
  {
    title: 'Knowledge Hub',
    href: '/knowledge'
  },
  {
    title: 'News',
    href: '/news'
  },
  {
    title: 'About us',
    href: '/About'
  },
  {
    title: 'Brand',
    href: '/brand'
  }
];

export const site_links = [
  {
    title: 'Important Alerts',
    href: '/important'
  },
  {
    title: 'Privacy policy',
    href: '/policy'
  },
  {
    title: 'Telemarketer registration',
    href: '/telemarketer'
  },
  {
    title: 'Site Index',
    href: '/site'
  },
  {
    title: 'Do not disturb list',
    href: '/disturb'
  }
];

export const section_links = [
  {
    title: 'Quick Access',
    links: [
      {
        title: 'Business Solutions',
        href: '/business'
      },
      {
        title: 'Client Area',
        href: '/client'
      },
      {
        title: 'Enterprise & Government',
        href: '/enterprise'
      },
      {
        title: 'Service Provider',
        href: '/service'
      }
    ]
  },
  {
    title: 'Help at Hand',
    links: [
      {
        title: 'FAQs',
        href: '/faqs'
      },
      {
        title: 'Find a Store',
        href: '/find'
      },
      {
        title: 'Give us Feedback',
        href: '/give'
      }
    ]
  },
  {
    title: 'New Connections',
    links: [
      {
        title: 'Business Internet',
        href: '/business'
      },
      {
        title: 'Global Voice',
        href: '/global'
      },
      {
        title: 'Global SMS',
        href: '/global'
      },
      {
        title: 'Landline',
        href: '/landline'
      }
    ]
  },
];

export const social_links = [
  {
    network: 'facebook',
    href: 'http://facebook.com'
  },
  {
    network: 'linkedin',
    href: 'http://linkedin.com'
  },
  {
    network: 'twitter',
    href: 'http://twitter.com'
  },
  {
    network: 'youtube',
    href: 'http://youtube.com'
  }
];



// WEBPACK FOOTER //
// ./src/containers/components/Footer/constants/links.js